<script>
import SectionTitle from '@components/section-title'
import con from '@services/connection'
import Vue from 'vue'
import { adicionarTransacao, dev } from '@constants/URL'
import { possivelJSON, validarData, getNumber } from '@utils/Format'
import store from '@state/store'
import { mask } from 'vue-the-mask'
import { MODAL, RELOAD, RUNNING } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import rules from '@constants/Rules'

function _getValue(v) {
  return typeof v === 'string' ? JSON.parse(v) : v
}

export default {
  directives: {
    mask,
  },
  components: {
    SectionTitle,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      step: 1,
      cod_banco: '',
      nome_banco: '',
      rules: rules,
      mask: {
        number: '#######################',
        cpf: '###.###.###-##',
        cnpj: '##.###.###/####-##',
      },
      bancos: [],
      banco: '',
      campos: [],
      cpf: '',
      agencia: '',
      conta: '',
      email: '',
      senha: '',
      cotizar_conta: false,
      edit_cotizar_conta: false,
      is_corretora: false,
      formValid: false,
      show1: false,
      check: false,
      loading: false,
      CODIGO_SANTANDER: 33,
      CODIGO_XP: 102,
      CODIGO_GENIAL: 278,
      CODIGO_CEI: 273,
      bank: {},
      id_conta: '',
      // Se o cliente deseja rodar o crawler diariamente.
      att_diaria: false,
      consegue_atualizar: false,
      // Se o cliente deseja que a AAWZ calcule o PL atual.
      cotizar_pl: false,
    }
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.CADASTRAR_CONTA, this.openModal)
      this.bus.$on('bank-account', this.openAccount)
    }
  },
  beforeDestroy() {
    if (this.bus) {
      this.bus.$off(MODAL.CADASTRAR_CONTA, this.openModal)
      this.bus.$off('bank-account', this.openAccount)
    }
  },
  methods: {
    openModal(v) {
      this.clearFields()
      this.busModal.$emit('dialog', v)
      this.getBancos()
    },
    openAccount(v) {
      if (v) {
        setTimeout(() => {
          console.log('bank-account', v)
          this.bank = v
          this.banco = v.id_banco
          this.id_conta = v.id_conta
          this.agencia = v.agencia
          this.conta = v.conta
          this.email = v.email
          this.cpf = v.cpf
          this.cotizar_conta = v.cotizar_conta
          this.edit_cotizar_conta = v.edit_cotizar_conta
          this.att_diaria = v.consentimento_aprovado
          this.consegue_atualizar = v._must_sign_agreement
          this.cotizar_pl = v.atualizar_pl_cotizacao
          this.collectFieldsRequireds()
          this.nextStep()
        }, 200)
      }
      console.log('Banco', this.bank, this.banco)
    },
    getBancos() {
      con
        .post(adicionarTransacao.bancos.listar, {
          somente_disponiveis: 1,
        })
        .then((res) => {
          if (res && res.status == 200) {
            let values = possivelJSON(res.value).map((v, i) => {
              v.nome = `${v.codigo} - ${v.nome}`
              v.nome_banco = v.nome
              return v
            })
            this.bancos = values
          }
        })
    },
    nextStep() {
      this.step = Number(this.step) + 1
    },
    getClientId() {
      return store.getters['user/currentClient'].id
    },
    newAccount(close) {
      if (this.loading) {
        return
      }
      if (!this.validateFields()) {
        return
      }
      this.loading = true
      const data = {
        id_banco: this.banco,
        id_conta: this.id_conta,
        conta: this.conta,
        senha: this.senha,
        agencia: this.agencia,
        cpf: this.cpf,
        email: this.email,
        consentimento_aprovado: this.att_diaria,
        consentimento_assinado: true,
        atualizar_pl_cotizacao: this.cotizar_pl,
      }
      if (this.edit_cotizar_conta || this.cod_banco === this.CODIGO_XP) {
        data['cotizar_conta'] = this.cotizar_conta
      }
      con
        .post(
          this.bank && this.bank.edit
            ? adicionarTransacao.bancos.edit
            : adicionarTransacao.bancos.add,
          data
        )
        .then((res) => {
          if (res && res.status === 200) {
            this.$showSnack({
              text: 'Conta de investimento registrada, preencha as informações dos ativos para calcular a rentabilidade',
              button: true,
            })
            const bank = {
              codigo: this.cod_banco,
              id_banco: this.banco,
              id_conta: this.id_conta || res.value,
              requisitos: this.campos,
            }
            // this.attBank(bank)
            this.clearFields()
            this.busModal.$emit('newBankAccount')
            GlobalBus.$emit(RELOAD.ACCOUNT)
            GlobalBus.$emit('attNewBank', bank.id_conta)
            GlobalBus.$emit(RUNNING.ATUALIZAR_BANCO, bank)
            close()
          } else {
            this.$showSnack({
              text: res.message,
              button: true,
            })
          }
          store.dispatch('user/checkIncompleteAsset')
          this.loading = false
        })
    },
    attBank(bank) {
      if (bank.requisitos.includes('token') && bank.is_valid) {
        this.$showSnack({
          text: 'Atualize a conta para coletar os dados',
          button: true,
        })
        return
      }
      con
        .post(adicionarTransacao.bancos.att, {
          codigo_banco: bank.codigo,
          id_banco: bank.id_banco,
          token: '',
          id_conta: bank.id_conta,
          async: false,
        })
        .then((r) => {
          if (r.status === 200) {
            GlobalBus.$emit(RELOAD.ACCOUNT)
          }
        })
      setTimeout(() => {
        GlobalBus.$emit(RELOAD.ACCOUNT)
      }, 300)
    },
    collectFieldsRequireds() {
      if (this.bank.edit) {
        this.cod_banco = this.bank.codigo
        this.campos = this.bank.requisitos
        this.nome_banco = this.bank.nome || this.bank.nome_banco
        this.isCorretora()
        return
      }
      let banco = this.bancos.find((v, i) => {
        return v.id_banco === this.banco
      })

      if (banco) {
        this.cod_banco = banco.codigo
        this.campos = banco.requisitos
        this.nome_banco = banco.nome_banco
      }
      this.isCorretora()
    },
    isCorretora() {
      this.is_corretora =
        this.cod_banco === this.CODIGO_GENIAL ||
        this.cod_banco === this.CODIGO_XP
    },
    validateFields() {
      this.$refs.form.validate()
      return this.formValid
    },
    openInsituicaoNaoEncontrada() {
      this.$showModal({
        text: 'Nós estamos integrados com as instituições disponíveis para cadastro, caso deseja cadastrar uma nova instituição você precisa cadastrar um novo produto, escolher a conta "Outros" e cadastrar na instituição desejada.',
        title: 'Instituição não encontrada',
        buttons: [
          {
            text: 'Ok',
            class: { underlined: true },
          },
          {
            text: 'Novo ativo',
            class: { primary: true },
            action: () => {
              this.busModal.$emit('dialog', false)
              GlobalBus.$emit(MODAL.CONSOLIDADOR_REGISTER_ASSET, {})
            },
          },
        ],
      })
    },
    clearFields() {
      this.step = 1
      this.cod_banco = ''
      this.nome_banco = ''
      this.banco = ''
      this.campos = []
      this.cpf = ''
      this.agencia = ''
      this.conta = ''
      this.email = ''
      this.senha = ''
      this.bank = {}
      this.id_conta = ''
      this.check = false
      this.cotizar_conta = false
      this.edit_cotizar_conta = false
      this.att_diaria = false
      this.consegue_atualizar = false
      this.cotizar_pl = false

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      if (this.$refs.formPrimary) {
        this.$refs.formPrimary.resetValidation()
      }
    },
  },
}
</script>

<template>
  <BaseModal max-width="900px" max-height="400px" :bus="busModal" persistent>
    <div>
      <div class="v-application">
        <SectionTitle
          :title="
            (bank.edit ? 'Editar' : 'Cadastrar') + ' conta de investimento'
          "
        />
      </div>
      <div>
        <v-stepper
          v-model="step"
          :style="{
            'margin-top': '20px',
          }"
          class="elevation-0"
        >
          <v-stepper-header v-if="!bank.edit" class="elevation-0">
            <v-stepper-step step="1" :complete="step > 1" :editable="step > 1">
              Escolha sua instituição
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2">
              {{ (bank.edit ? 'Edite' : 'Cadastre') + ' sua conta' }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items class="elevation-0">
            <v-stepper-content step="1">
              <v-form ref="formPrimary">
                <div v-if="banco === 273" style="margin-bottom: 20px">
                  <small style="text-align: justify" class="text-secondary">
                    As informações do CEI são consolidadas em D-2, movimentações
                    feitas após esse período podem não ser refletidas aqui em
                    sua carteira.
                  </small>
                  <small style="text-align: justify" class="text-secondary">
                    Os dados possuem histórico de até 1 ano e meio e Títulos
                    Públicos e Renda Fixa não são consolidados automaticamente,
                    insira manualmente em Cadastro -> Ativo.
                  </small>
                </div>
                <v-select
                  v-model="banco"
                  :class="$style.fields"
                  :items="bancos"
                  label="Selecione sua instituição*"
                  item-text="nome"
                  item-value="id_banco"
                  required
                  :rules="[rules.required]"
                  @change="collectFieldsRequireds"
                />

                <div
                  style="cursor: pointer"
                  @click="openInsituicaoNaoEncontrada"
                >
                  <p
                    style="
                      margin-top: 20px;
                      text-decoration: underline;
                      color: primary;
                    "
                  >
                    Não encontrou a instituição desejada?
                  </p>
                </div>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-form ref="form" v-model="formValid">
                <v-text-field
                  v-if="campos.includes('cpf') && banco !== CODIGO_CEI"
                  v-model="cpf"
                  v-mask="mask.cpf"
                  :class="$style.fields"
                  label="CPF*"
                  :rules="[rules.required]"
                />
                <v-text-field
                  v-if="campos.includes('cpf') && banco === CODIGO_CEI"
                  v-model="cpf"
                  v-mask="[mask.cpf, mask.cnpj]"
                  :class="$style.fields"
                  label="CPF/CNPJ*"
                  :rules="[rules.required, rules.cpf_cnpj]"
                />
                <v-text-field
                  v-if="campos.includes('agencia')"
                  v-model="agencia"
                  v-mask="mask.number"
                  :class="$style.fields"
                  :label="
                    cod_banco === 341 || cod_banco === 237
                      ? 'Agência*'
                      : 'Agência com digito*'
                  "
                  :rules="[rules.required]"
                />
                <v-text-field
                  v-if="campos.includes('conta')"
                  v-model="conta"
                  v-mask="mask.number"
                  :class="$style.fields"
                  :label="
                    is_corretora
                      ? 'Conta corretora*'
                      : 'Conta corrente com dígito*'
                  "
                  :rules="[rules.required]"
                />
                <v-text-field
                  v-if="campos.includes('email')"
                  v-model="email"
                  :class="$style.fields"
                  label="E-mail*"
                  :rules="[rules.email]"
                />
                <div v-if="campos.includes('senha')">
                  <p :class="$style.obrigatorio">
                    A senha do internet banking é a senha de acesso a sua conta
                    e que nos possibilita apenas a visualização dos seus dados,
                    não podemos realizar nenhuma ação em sua conta com ela.
                  </p>
                  <v-text-field
                    v-model="senha"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    :class="$style.fields"
                    :label="
                      is_corretora
                        ? 'Senha corretora*'
                        : 'Senha internet banking*'
                    "
                    :rules="[rules.required]"
                    @click:append="show1 = !show1"
                  />
                </div>
                <p
                  v-if="cod_banco === CODIGO_SANTANDER"
                  :class="$style.obrigatorio"
                >
                  Não se preocupe caso você receba uma mensagem do Santander
                  pedindo para autorizar/habilitar a AAWZ no caixa eletrônico.
                  Nosso acesso é apenas de visualização.</p
                >
                <div v-if="edit_cotizar_conta || cod_banco === CODIGO_XP">
                  <v-switch
                    v-model="cotizar_conta"
                    label="Não coletar informações da rentabilidade."
                    dense
                    hide-details
                  />
                </div>
                <div>
                  <v-switch
                    v-model="cotizar_pl"
                    label="Não coletar informações do saldo bruto."
                    dense
                    hide-details
                  />
                </div>
                <div>
                  <v-switch
                    v-model="att_diaria"
                    label="Atualizar dados automaticamente todos os dias."
                    dense
                    hide-details
                  />
                </div>
                <div>
                  <v-checkbox
                    v-model="check"
                    required
                    :rules="[rules.required]"
                    :label="`Autorizo o acesso a meus dados financeiros pessoais na instituição ${nome_banco} somente em modo leitura`"
                  ></v-checkbox>
                </div>
                <p :class="$style.obrigatorio">* Obrigatório</p>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton v-if="step === 1" underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton v-if="step === 2 && bank.edit" underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton
        v-if="step === 2 && !bank.edit"
        underlined
        @click="step = Number(step) - 1"
      >
        Voltar
      </BaseButton>
      <BaseButton v-if="step === 1 && !banco" secondary> Confirmar </BaseButton>
      <BaseButton v-if="step === 1 && banco" primary @click="nextStep">
        Confirmar
      </BaseButton>
      <BaseButton
        v-if="step === 2 && bank.edit"
        primary
        :loading="loading"
        @click="newAccount(close)"
      >
        Editar
      </BaseButton>
      <BaseButton
        v-if="step === 2 && !bank.edit"
        primary
        :loading="loading"
        @click="newAccount(close)"
      >
        Cadastrar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass" module>
.fields
  margin-top: 10px

.obrigatorio
  font-size: 12px
  color: gray
  margin-left: 0px !important

.buttons
  margin-left: 0px !important
  width: 100% !important
  bottom: 20px
</style>
